import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { UserDataService } from '../../../../../shared/services/auth/userData.service';
import { ActivatedRoute } from '@angular/router';
import { IThreatAssessmentTeam } from '../../../../../shared/models/contact';
import { ContactsService } from '../../../../../shared/services/contact.service';
import { SpinnerComponent } from '../../../../components/spinner/spinner.component';

@Component({
  selector: 'rms-plan-summary-signature',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent
  ],
  templateUrl: './rms-plan-summary-signature.component.html',
  styleUrl: './rms-plan-summary-signature.component.css'
})
export class RmsPlanSummarySignatureComponent implements OnInit, OnChanges {

  @Input() rmsPlanSummaryData: any;
  @Output() onSaveSection2 = new EventEmitter<any>();

  rmsPlanSummarySignatureForm: FormGroup = new FormGroup([]);
    
  currentDate = new Date();
  currentCaseId: string | null = null;
  currentBuildingId: string | null = null;
  currentContact: IThreatAssessmentTeam | null = null;
  messageModal: string | null = null;

  loading: boolean = false;

  constructor(
    private contactsService: ContactsService,
    private route: ActivatedRoute,
    private userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.currentContact = this.userDataService.getCurrentUser();

    this.initializeForm();
    
    this.route.paramMap.subscribe((params) => {
      this.currentCaseId = params.get('caseId');
    });
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rmsPlanSummaryData'] && this.rmsPlanSummaryData) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.rmsPlanSummarySignatureForm = new FormGroup({
      user_signature_name: new FormControl('', Validators.required),
    });
  }

  saveRmsPlanSummarySignature(): void {
    if (this.rmsPlanSummarySignatureForm.valid) {
        this.onSaveSection2.emit(this.rmsPlanSummarySignatureForm.value);
    }
  }
}
